// export const base_path = "http://localhost:3000/react/template/";
export const base_path = "/";
